(function ($) {

    // check screen width (mobile or desktop)
    function isMobile() {
        return $(window).width() <= 768;
    }

    //blocks with accordion
    function accordionFunc(e) {
        e.preventDefault();
        if ($(e.currentTarget).hasClass('active')) {
            $(e.currentTarget).removeClass('active');
            $(e.currentTarget).next()
                .removeClass('active')
                .stop()
                .slideUp(300);
        } else {
            $(e.currentTarget).addClass('active');
            $(e.currentTarget).next()
                .addClass('active')
                .stop()
                .slideDown(300);
        }
    }

    //accordion for footer
    function initFooterAccordion() {
        $init = $(".f-col-wrapper .f-header").attr('init-accordion');
        $accordionHeader = $('.f-col-wrapper .f-header');

        if ( isMobile() ) {
            if ($init != 'true') {
                $accordionHeader.attr('init-accordion', "true");
                $accordionHeader.removeClass('active').next().css({'display': 'none'});
                $accordionHeader.on('click', accordionFunc);
            }
        }
        //if desktop
        else {
            if ($init == 'true') {
                $accordionHeader.attr('init-accordion', "false");
                $accordionHeader.next().removeClass('active').css({'display': 'block'});
                $accordionHeader.off('click', accordionFunc);
            }
            $('.f-col-wrapper .f-header').off('click', accordionFunc);
        }
    }

    //accordion for internal-links section (mobile)
    function initInternalLinksAccordion() {
        $init = $(".internal-links .column__title").attr('init-accordion');
        $accordionHeader = $('.internal-links .column__title');

        if ( isMobile() ) {
            if ($init != 'true') {
                $accordionHeader.attr('init-accordion', "true");
                $accordionHeader.removeClass('active').next().css({'display': 'none'});
                $accordionHeader.on('click', accordionFunc);
            }
        }
        //if desktop
        else {
            if ($init == 'true') {
                $accordionHeader.attr('init-accordion', "false");
                $accordionHeader.next().removeClass('active').css({'display': 'block'});
                $accordionHeader.off('click', accordionFunc);
            }
            $('.internal-links .column__title').off('click', accordionFunc);
        }
    }

    // trigger load/resize/orientationchange event
    $(window).on('load resize orientationchange', function() {
        isMobile();
        initFooterAccordion();
        initInternalLinksAccordion();
    });

})(jQuery);